import * as angular from "angular";
import {IController} from 'angular';
import * as _ from "lodash";

export class customersMultiSelectCtrl implements IController {

  selectedIds: any;
  options: any;
  ngPlaceholder: any;
  excludeIds: any;
  accountIds: string[];
  isDisabled: any;
  isRequired: boolean;
  onChange: Function;

  private customersRef: any;
  public selectedCustomers: any;
  public selectedText: any;

  /* @ngInject */
  constructor(private $mdPanel, private $customers, private $element) {
    this.customersRef = this.$customers();
  }

  $onInit() {
    this._setSelectedCustomers();
  };

  $onChanges(changes) {
    if (changes.selectedIds && !changes.selectedIds.isFirstChange()) {
      this._setSelectedCustomers();
    }
  };


  onShowPanel($event) {

    if (!!this.isDisabled) {
      return;
    }

    const panelPosition = this.$mdPanel.newPanelPosition()
      .relativeTo($event.target)
      .addPanelPosition(
        this.$mdPanel.xPosition.CENTER,
        this.$mdPanel.yPosition.BELOW // yPosition.BELOW
      );

    const panelAnimation = this.$mdPanel.newPanelAnimation()
      .openFrom($event)
      .duration(200)
      .closeTo('.bringoz-select-input')
      .withAnimation(this.$mdPanel.animation.FADE);

    const selectedIdsRef = this.selectedIds || [];
    const optionsRef = this.options;
    const excludeIdsRef = this.excludeIds;
    const ngPlaceholderRef = this.ngPlaceholder;
    const accountIdsRef = this.accountIds;

    const config = {
      attachTo: angular.element(document.body),
      controllerAs: 'ctrl',
      position: panelPosition,
      animation: panelAnimation,
      targetEvent: $event,
      template: '<bringoz-multi-select-filter-panel ' +
        'type="ctrl.typeRef" ' +
        'selected-ids="ctrl.selectedIdsRef" ' +
        'options="ctrl.optionsRef" ' +
        'account-ids="ctrl.accountIdsRef" ' +
        'ng-placeholder="ctrl.ngPlaceholderRef" ' +
        'panel-ref="ctrl.mdPanelRef" ' +
        'exclude-ids="ctrl.excludeIdsRef">' +
        '</bringoz-multi-select-filter-panel>',
      controller: function () {
        this.typeRef = 'customers';
        this.selectedIdsRef = selectedIdsRef;
        this.optionsRef = optionsRef;
        this.ngPlaceholderRef = ngPlaceholderRef;
        this.excludeIdsRef = excludeIdsRef;
        this.accountIdsRef = accountIdsRef;
      },
      clickOutsideToClose: true,
      escapeToClose: true,
      focusOnOpen: true,
      zIndex: 80,
      onCloseSuccess: (panel, selectedIds) => {
        if (selectedIds === 'clickOutsideToClose' || selectedIds === 'escapeToClose') {
          selectedIds = selectedIdsRef;
        }

        if (!selectedIds?.length) {
          this.onChange({customers: [], selectedIds: []});
          panel.destroy();
        } else {
          if (!!this.options) {
            const customers = _.filter(this.options, (o) => {
              return _.includes(selectedIds, o.id);
            });
            this.onChange({customers: customers, selectedIds: selectedIds});
            panel.destroy();
          } else {
            this.customersRef.$asyncValues(selectedIds)
              .then((customers: any[]) => {
                this.onChange({customers: customers, selectedIds: selectedIds});
                panel.destroy();
              });
          }
        }
        panel.destroy();
      }
    };

    this.$mdPanel.open(config);
  }

  onResetFilter() {
    this.onChange({selectedIds: []});
  }

  private _setSelectedCustomers() {
    if (!!this.selectedIds?.length) {
      if (!!this.options) {
        this.selectedCustomers = _.filter(this.options, (o) => {
          return _.includes(this.selectedIds, o.id);
        });
        this._setSelectedText();
      } else {
        this.customersRef.$asyncValues(this.selectedIds)
          .then((customers: any[]) => {
            this.selectedCustomers = _.orderBy(customers, ['firstName'], ['asc']);
            this._setSelectedText();
          })
      }
    } else {
      this.selectedCustomers = [];
      this._setSelectedText();
    }
  }

  private _setSelectedText() {
    let string = '';
    var canvas = document.createElement('canvas');
    var ctx = canvas.getContext("2d");

    _.forEach(this.selectedCustomers, (c, i) => {
      string += `${c.firstName} ${c.lastName}`;
      if ((i + 1) < this.selectedCustomers.length) {
        string += ', '
      }
    });

    var stringWidth = ctx.measureText(string).width;
    if (this.$element[0]?.clientWidth && (stringWidth + 80) >= (this.$element[0].clientWidth - 30)) {
      string = `${this.selectedCustomers[0].firstName} ${this.selectedCustomers[0].lastName}` + ` +${this.selectedCustomers.length - 1}`
    }
    this.selectedText = string;
  }


}

angular
  .module('bringoz.admin.customers')
  .component('customersMultiSelect', {
    bindings: {
      selectedIds: '<?',
      options: '<?',
      ngPlaceholder: '@?',
      accountIds: '<?',
      excludeIds: '<?',
      isDisabled: '<?',
      isRequired: '<?',
      onChange: '&'
    },
    template: require('./customers-multi-select.html').default,
    controller: customersMultiSelectCtrl
  });
